// extracted by mini-css-extract-plugin
export default {"tableWrap":"Table_tableWrap__7JcCF","table":"Table_table__IeAhL","truncateCell":"Table_truncateCell__rE2pp","empty":"Table_empty__PB1uw","error":"Table_error__eSyh-"};